import { render } from "./BingShiView.vue?vue&type=template&id=564efb9c&scoped=true&ts=true"
import script from "./BingShiView.vue?vue&type=script&lang=ts"
export * from "./BingShiView.vue?vue&type=script&lang=ts"

import "./BingShiView.vue?vue&type=style&index=0&id=564efb9c&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564efb9c"]])

export default __exports__